<!-- Modal Overlay -->
<div class="modal-overlay" (click)="onClose()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="modal-header">
      <h2 class="modal-title">
        {{ initialData ? 'Edit Email Campaign' : 'Create Email Campaign' }}
      </h2>
      <button class="close-btn" (click)="onClose()">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="#555963"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Modal Content -->
    <div class="modal-content">
      <div class="modal-side-container">
        <!-- Basic Info Section -->
        <div class="form-section">
          <h3 class="section-title">Basic Info <span class="required">*</span></h3>

          <div class="form-group">
            <label class="form-label">Email subject line<span class="required">*</span></label>
            <input
              type="text"
              class="form-input"
              [class.error]="validationErrors.subject"
              placeholder="ex. Black Friday 50% Off Car Wash"
              [(ngModel)]="emailData.subject"
              maxlength="200"
              (input)="onSubjectChange()"
            />
            <div class="error-message" *ngIf="validationErrors.subject">
              {{ validationErrors.subject }}
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">From email address<span class="required">*</span></label>
            <input
              type="email"
              class="form-input"
              [class.error]="validationErrors.fromEmail"
              placeholder="ex. abcwash@email.com"
              [(ngModel)]="emailData.fromEmail"
              maxlength="254"
              (input)="onFromEmailChange()"
            />
            <div class="error-message" *ngIf="validationErrors.fromEmail">
              {{ validationErrors.fromEmail }}
            </div>
          </div>
        </div>

        <!-- Header Section -->
        <div class="form-section">
          <h3 class="section-title">Header</h3>

          <div class="form-group">
            <label class="form-label">Logo<span class="required">*</span></label>
            <div
              class="file-upload-container"
              [class.error]="validationErrors.logo || fileValidationErrors.logo"
            >
              <div class="file-upload-area" *ngIf="!emailData.logo && !emailData.logoUrl">
                <input
                  type="file"
                  id="logo-upload"
                  accept=".png,.jpg,.jpeg,image/png,image/jpeg,image/jpg"
                  (change)="onLogoUpload($event)"
                  class="file-input"
                />
                <ng-container
                  *ngTemplateOutlet="
                    uploadAreaLabel;
                    context: { inputId: 'logo-upload', dimensions: maxLogoDimensions }
                  "
                ></ng-container>
              </div>

              <div class="file-uploaded" *ngIf="emailData.logo || emailData?.logoUrl">
                <div class="uploaded-file">
                  <div class="success-icon" *ngIf="!isUploadingLogo">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="8" cy="8" r="6" fill="#079271" />
                      <path
                        d="M5.5 8L7 9.5L10.5 6"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="loading-spinner-icon" *ngIf="isUploadingLogo">
                    <div class="spinner"></div>
                  </div>

                  <span class="file-name">{{ emailData.logo?.name || emailData.logoUrl }}</span>
                  <button class="remove-file" (click)="removeLogo()" [disabled]="isUploadingLogo">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 3L3 9M3 3L9 9"
                        stroke="#A7ABB3"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="error-message" *ngIf="validationErrors.logo">
              {{ validationErrors.logo }}
            </div>
            <div class="error-message" *ngIf="fileValidationErrors.logo">
              {{ fileValidationErrors.logo }}
            </div>
          </div>
        </div>

        <!-- Body Section -->
        <div class="form-section">
          <h3 class="section-title">Body</h3>

          <div class="form-group">
            <label class="form-label">Image<span class="required">*</span></label>
            <div
              class="file-upload-container"
              [class.error]="validationErrors.image || fileValidationErrors.image"
            >
              <div class="file-upload-area" *ngIf="!emailData.image && !emailData.imageUrl">
                <input
                  type="file"
                  id="image-upload"
                  accept=".png,.jpg,.jpeg,image/png,image/jpeg,image/jpg"
                  (change)="onImageUpload($event)"
                  class="file-input"
                />
                <ng-container
                  *ngTemplateOutlet="
                    uploadAreaLabel;
                    context: { inputId: 'image-upload', dimensions: maxImageDimensions }
                  "
                ></ng-container>
              </div>

              <div class="file-uploaded" *ngIf="emailData.image || emailData.imageUrl">
                <div class="uploaded-file">
                  <div class="success-icon" *ngIf="!isUploadingImage">
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="8" cy="8" r="6" fill="#079271" />
                      <path
                        d="M5.5 8L7 9.5L10.5 6"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </div>
                  <div class="loading-spinner-icon" *ngIf="isUploadingImage">
                    <div class="spinner"></div>
                  </div>
                  <span class="file-name">{{ emailData.image?.name || emailData.imageUrl }}</span>
                  <button class="remove-file" (click)="removeImage()" [disabled]="isUploadingImage">
                    <svg
                      width="12"
                      height="12"
                      viewBox="0 0 12 12"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9 3L3 9M3 3L9 9"
                        stroke="#A7ABB3"
                        stroke-width="1.5"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
            <div class="error-message" *ngIf="validationErrors.image">
              {{ validationErrors.image }}
            </div>
            <div class="error-message" *ngIf="fileValidationErrors.image">
              {{ fileValidationErrors.image }}
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Email Header<span class="required">*</span></label>
            <div class="input-with-tags">
              <input
                type="text"
                class="form-input"
                [class.error]="validationErrors.header"
                placeholder="Email Header"
                [(ngModel)]="emailData.header"
                maxlength="200"
                (input)="onHeaderChange()"
              />
              <div class="tags-container">
                <span
                  class="tag"
                  *ngFor="let tag of availableTags; trackBy: trackByIndex"
                  (click)="insertTag(tag, 'header')"
                  >{{ tag }}</span
                >
              </div>
            </div>
            <div class="error-message" *ngIf="validationErrors.header">
              {{ validationErrors.header }}
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Email Body Text<span class="required">*</span></label>
            <div class="rich-text-editor" [class.error]="validationErrors.bodyText">
              <quill-editor
                [(ngModel)]="emailData.bodyText"
                [styles]="{ height: '200px' }"
                [modules]="editorModules"
                (onContentChanged)="onBodyTextChange()"
                placeholder="Write the text of your email here. Describe the offers in this campaign and why it can't be missed."
              >
              </quill-editor>
            </div>
            <div class="error-message" *ngIf="validationErrors.bodyText">
              {{ validationErrors.bodyText }}
            </div>
          </div>
          <div class="tags-row">
            <span class="tag" (click)="insertTag('Customer_Name', 'bodyText')">Customer_Name</span>
            <span class="tag" (click)="insertTag('Customer_Email', 'bodyText')"
              >Customer_Email</span
            >
            <span class="tag" (click)="insertTag('Last_Visit_Date', 'bodyText')"
              >Last_Visit_Date</span
            >
          </div>

          <!-- Body 2 Section -->
          <div class="form-group" *ngIf="activeTextBlocks.includes(2)">
            <div class="body2-header">
              <label class="form-label">Body 2<span class="required">*</span></label>
              <button class="remove-body2" (click)="removeBody2()">
                <svg
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.599609 3.59961H12.5996M5.09961 6.59961V11.0996M8.09961 6.59961V11.0996M1.34961 3.59961L2.09961 12.5996C2.09961 12.9974 2.25764 13.379 2.53895 13.6603C2.82025 13.9416 3.20178 14.0996 3.59961 14.0996H9.59961C9.99743 14.0996 10.379 13.9416 10.6603 13.6603C10.9416 13.379 11.0996 12.9974 11.0996 12.5996L11.8496 3.59961M4.34961 3.59961V1.34961C4.34961 1.1507 4.42863 0.959932 4.56928 0.819279C4.70993 0.678627 4.9007 0.599609 5.09961 0.599609H8.09961C8.29852 0.599609 8.48929 0.678627 8.62994 0.819279C8.77059 0.959932 8.84961 1.1507 8.84961 1.34961V3.59961"
                    stroke="#AF1820"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div class="rich-text-editor" [class.error]="validationErrors.body2Text">
              <quill-editor
                [(ngModel)]="emailData.body2Text"
                [styles]="{ height: '200px' }"
                [modules]="editorModules"
                (onContentChanged)="onBody2TextChange()"
                placeholder="Write the text of your email here. Describe the offers in this campaign and why it can't be missed."
              >
              </quill-editor>
            </div>
            <div class="error-message" *ngIf="validationErrors.body2Text">
              {{ validationErrors.body2Text }}
            </div>
          </div>
          <div class="tags-row" *ngIf="activeTextBlocks.includes(2)">
            <span class="tag" (click)="insertTag('Customer_Name', 'body2Text')">Customer_Name</span>
            <span class="tag" (click)="insertTag('Customer_Email', 'body2Text')"
              >Customer_Email</span
            >
            <span class="tag" (click)="insertTag('Last_Visit_Date', 'body2Text')"
              >Last_Visit_Date</span
            >
          </div>

          <!-- Body 3 Section -->
          <div class="form-group" *ngIf="activeTextBlocks.includes(3)">
            <div class="body2-header">
              <label class="form-label">Body 3<span class="required">*</span></label>
              <button class="remove-body2" (click)="removeBody3()">
                <svg
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.599609 3.59961H12.5996M5.09961 6.59961V11.0996M8.09961 6.59961V11.0996M1.34961 3.59961L2.09961 12.5996C2.09961 12.9974 2.25764 13.379 2.53895 13.6603C2.82025 13.9416 3.20178 14.0996 3.59961 14.0996H9.59961C9.99743 14.0996 10.379 13.9416 10.6603 13.6603C10.9416 13.379 11.0996 12.9974 11.0996 12.5996L11.8496 3.59961M4.34961 3.59961V1.34961C4.34961 1.1507 4.42863 0.959932 4.56928 0.819279C4.70993 0.678627 4.9007 0.599609 5.09961 0.599609H8.09961C8.29852 0.599609 8.48929 0.678627 8.62994 0.819279C8.77059 0.959932 8.84961 1.1507 8.84961 1.34961V3.59961"
                    stroke="#AF1820"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div class="rich-text-editor" [class.error]="validationErrors.body3Text">
              <quill-editor
                [(ngModel)]="emailData.body3Text"
                [styles]="{ height: '200px' }"
                [modules]="editorModules"
                (onContentChanged)="onBody3TextChange()"
                placeholder="Write the text of your email here. Describe the offers in this campaign and why it can't be missed."
              >
              </quill-editor>
            </div>
            <div class="error-message" *ngIf="validationErrors.body3Text">
              {{ validationErrors.body3Text }}
            </div>
          </div>
          <div class="tags-row" *ngIf="activeTextBlocks.includes(3)">
            <span class="tag" (click)="insertTag('Customer_Name', 'body3Text')">Customer_Name</span>
            <span class="tag" (click)="insertTag('Customer_Email', 'body3Text')"
              >Customer_Email</span
            >
            <span class="tag" (click)="insertTag('Last_Visit_Date', 'body3Text')"
              >Last_Visit_Date</span
            >
          </div>

          <!-- Body 4 Section -->
          <div class="form-group" *ngIf="activeTextBlocks.includes(4)">
            <div class="body2-header">
              <label class="form-label">Body 4<span class="required">*</span></label>
              <button class="remove-body2" (click)="removeBody4()">
                <svg
                  width="14"
                  height="15"
                  viewBox="0 0 14 15"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M0.599609 3.59961H12.5996M5.09961 6.59961V11.0996M8.09961 6.59961V11.0996M1.34961 3.59961L2.09961 12.5996C2.09961 12.9974 2.25764 13.379 2.53895 13.6603C2.82025 13.9416 3.20178 14.0996 3.59961 14.0996H9.59961C9.99743 14.0996 10.379 13.9416 10.6603 13.6603C10.9416 13.379 11.0996 12.9974 11.0996 12.5996L11.8496 3.59961M4.34961 3.59961V1.34961C4.34961 1.1507 4.42863 0.959932 4.56928 0.819279C4.70993 0.678627 4.9007 0.599609 5.09961 0.599609H8.09961C8.29852 0.599609 8.48929 0.678627 8.62994 0.819279C8.77059 0.959932 8.84961 1.1507 8.84961 1.34961V3.59961"
                    stroke="#AF1820"
                    stroke-width="1.2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </button>
            </div>
            <div class="rich-text-editor" [class.error]="validationErrors.body4Text">
              <quill-editor
                [(ngModel)]="emailData.body4Text"
                [styles]="{ height: '200px' }"
                [modules]="editorModules"
                (onContentChanged)="onBody4TextChange()"
                placeholder="Write the text of your email here. Describe the offers in this campaign and why it can't be missed."
              >
              </quill-editor>
            </div>
            <div class="error-message" *ngIf="validationErrors.body4Text">
              {{ validationErrors.body4Text }}
            </div>
          </div>
          <div class="tags-row" *ngIf="activeTextBlocks.includes(4)">
            <span class="tag" (click)="insertTag('Customer_Name', 'body4Text')">Customer_Name</span>
            <span class="tag" (click)="insertTag('Customer_Email', 'body4Text')"
              >Customer_Email</span
            >
            <span class="tag" (click)="insertTag('Last_Visit_Date', 'body4Text')"
              >Last_Visit_Date</span
            >
          </div>

          <!-- Add Text Block Button -->
          <div
            class="add-text-block"
            (click)="addTextBlock()"
            [class.disabled]="!canAddTextBlock()"
            [style.pointer-events]="canAddTextBlock() ? 'auto' : 'none'"
          >
            <div class="add-content">
              <span class="add-text">Add Text Block</span>
            </div>
            <div class="plus-icon">
              <svg
                width="14"
                height="14"
                viewBox="0 0 14 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M7 1V13M1 7H13"
                  stroke="#0030A8"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>

        <!-- Button Section -->
        <div class="form-section">
          <h3 class="section-title">Button</h3>

          <div class="form-group">
            <label class="form-label"
              >Add the button text here<span class="required">*</span></label
            >
            <input
              type="text"
              class="form-input"
              [class.error]="validationErrors.buttonText"
              placeholder="Add the button text here"
              [(ngModel)]="emailData.buttonText"
              maxlength="50"
              (input)="onButtonTextChange()"
            />
            <div class="error-message" *ngIf="validationErrors.buttonText">
              {{ validationErrors.buttonText }}
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Button position<span class="required">*</span></label>
            <mat-radio-group
              class="radio-group"
              name="buttonPosition"
              [(ngModel)]="emailData.buttonPosition"
            >
              <mat-radio-button value="bottom" inputId="bottom"></mat-radio-button>
              <label for="bottom" class="radio-label">Bottom</label>

              <mat-radio-button value="top" inputId="top"></mat-radio-button>
              <label for="top" class="radio-label">Top</label>
            </mat-radio-group>
          </div>

          <div class="form-group">
            <label class="form-label">Button Color<span class="required">*</span></label>
            <div class="color-picker">
              <div
                class="color-option"
                *ngFor="let color of buttonColors; trackBy: trackByIndex"
                [class.selected]="emailData.buttonColor === color.value"
                (click)="selectButtonColor(color.value)"
              >
                <div class="color-circle" [style.background-color]="color.value">
                  <svg
                    *ngIf="emailData.buttonColor === color.value"
                    width="14"
                    height="14"
                    viewBox="0 0 14 14"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M3.5 7L6 9.5L10.5 4.5"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer Section -->
        <div class="form-section">
          <h3 class="section-title">Footer</h3>

          <div class="footer-grid">
            <div class="form-group">
              <label class="form-label">Car Wash Name</label>
              <input
                type="text"
                class="form-input"
                [class.error]="validationErrors.carWashName"
                placeholder="e.g. ABC Car Wash"
                [(ngModel)]="emailData.carWashName"
                maxlength="100"
                (input)="filterSpecialChars($event, 'carWashName')"
              />
              <div class="error-message" *ngIf="validationErrors.carWashName">
                {{ validationErrors.carWashName }}
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Street</label>
              <input
                type="text"
                class="form-input"
                [class.error]="validationErrors.street"
                placeholder="e.g. 55 street"
                [(ngModel)]="emailData.street"
                maxlength="200"
                (input)="filterSpecialChars($event, 'street')"
              />
              <div class="error-message" *ngIf="validationErrors.street">
                {{ validationErrors.street }}
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">City</label>
              <input
                type="text"
                class="form-input"
                [class.error]="validationErrors.city"
                placeholder="e.g. Jacksonville"
                [(ngModel)]="emailData.city"
                maxlength="100"
                (input)="filterSpecialChars($event, 'city')"
              />
              <div class="error-message" *ngIf="validationErrors.city">
                {{ validationErrors.city }}
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">State</label>
              <input
                type="text"
                class="form-input"
                [class.error]="validationErrors.state"
                placeholder="e.g.Texas"
                [(ngModel)]="emailData.state"
                maxlength="50"
                (input)="filterSpecialChars($event, 'state')"
              />
              <div class="error-message" *ngIf="validationErrors.state">
                {{ validationErrors.state }}
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">ZIP Code</label>
              <input
                type="text"
                class="form-input"
                [class.error]="validationErrors.zipCode"
                placeholder="e.g. 8123897"
                [(ngModel)]="emailData.zipCode"
                maxlength="10"
                (input)="filterSpecialChars($event, 'zipCode')"
              />
              <div class="error-message" *ngIf="validationErrors.zipCode">
                {{ validationErrors.zipCode }}
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Reply-to Email</label>
              <input
                type="email"
                class="form-input"
                [class.error]="validationErrors.email"
                placeholder="e.g. youremail@email.com"
                [(ngModel)]="emailData.email"
                maxlength="254"
              />
              <div class="error-message" *ngIf="validationErrors.email">
                {{ validationErrors.email }}
              </div>
            </div>

            <div class="form-group">
              <label class="form-label">Phone Number</label>
              <input
                type="tel"
                class="form-input"
                [class.error]="validationErrors.phoneNumber"
                placeholder="e.g. (555) 123-4567"
                [(ngModel)]="emailData.phoneNumber"
                maxlength="20"
                (input)="onPhoneNumberChange()"
                (blur)="onPhoneNumberChange()"
              />
              <div class="error-message" *ngIf="validationErrors.phoneNumber">
                {{ validationErrors.phoneNumber }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Email Preview -->
      <div class="email-preview-section">
        <div class="preview-header">
          <div class="preview-info">
            <div class="preview-subject">Subject: {{ emailData.subject }}</div>
            <div class="preview-from">From: {{ emailData.fromEmail }}</div>
          </div>
          <div class="preview-tabs">
            <button
              class="tab-btn"
              [class.active]="activeTab === 'desktop'"
              (click)="switchTab('desktop')"
            >
              <svg
                width="16"
                height="14"
                viewBox="0 0 16 14"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M4.25 13H11.75M5.75 10V13M10.25 10V13M1.25 1.75C1.25 1.55109 1.32902 1.36032 1.46967 1.21967C1.61032 1.07902 1.80109 1 2 1H14C14.1989 1 14.3897 1.07902 14.5303 1.21967C14.671 1.36032 14.75 1.55109 14.75 1.75V9.25C14.75 9.44891 14.671 9.63968 14.5303 9.78033C14.3897 9.92098 14.1989 10 14 10H2C1.80109 10 1.61032 9.92098 1.46967 9.78033C1.32902 9.63968 1.25 9.44891 1.25 9.25V1.75Z"
                  stroke="#15172E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
            <button
              class="tab-btn"
              [class.active]="activeTab === 'mobile'"
              (click)="switchTab('mobile')"
            >
              <svg
                width="12"
                height="16"
                viewBox="0 0 12 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.25 2H6.75M6 11.75V11.7575M1.5 2.75C1.5 2.35218 1.65804 1.97064 1.93934 1.68934C2.22064 1.40804 2.60218 1.25 3 1.25H9C9.39782 1.25 9.77936 1.40804 10.0607 1.68934C10.342 1.97064 10.5 2.35218 10.5 2.75V13.25C10.5 13.6478 10.342 14.0294 10.0607 14.3107C9.77936 14.592 9.39782 14.75 9 14.75H3C2.60218 14.75 2.22064 14.592 1.93934 14.3107C1.65804 14.0294 1.5 13.6478 1.5 13.25V2.75Z"
                  stroke="#15172E"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </button>
          </div>
        </div>

        <div class="preview" [class.mobilepreview]="activeTab === 'mobile'">
          <app-email-preview
            [emailData]="emailData"
            (viewInBrowser)="onViewInBrowser()"
          ></app-email-preview>
        </div>
      </div>
    </div>

    <!-- Modal Footer -->
    <div class="modal-footer">
      <button class="btn btn-secondary btn-large" (click)="onSendTest()">Send Test Email</button>
      <button class="btn btn-primary btn-large" (click)="onSave()">
        {{ initialData ? 'Update' : 'Save' }}
      </button>
    </div>
  </div>
</div>

<!-- Test Email Modal -->
<div class="test-email-modal-overlay" *ngIf="showTestEmailModal" (click)="onCloseTestEmailModal()">
  <div class="test-email-modal-container" (click)="$event.stopPropagation()">
    <!-- Test Email Modal Header -->
    <div class="test-email-modal-header">
      <h3 class="test-email-modal-title">Send Test Email</h3>
      <button class="test-email-close-btn" (click)="onCloseTestEmailModal()">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M13 1L1 13M1 1L13 13"
            stroke="#555963"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </button>
    </div>

    <!-- Test Email Modal Content -->
    <div class="test-email-modal-content">
      <!-- Email Preview Section -->
      <div class="test-email-preview">
        <div class="email-icon">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M22 6L12 13L2 6"
              stroke="#555963"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <div class="email-preview-info">
          <div class="email-preview-subject">
            Subject: {{ emailData.subject || 'Black Friday 50% Off' }}
          </div>
          <div class="email-preview-from">
            From: {{ emailData.fromEmail || 'abcwash@email.com' }}
          </div>
        </div>
      </div>

      <!-- Email Input Section -->
      <div class="test-email-input-section">
        <label class="test-email-label">Send test email to</label>
        <input
          type="email"
          class="test-email-input"
          placeholder="abcwash@email.com"
          [(ngModel)]="testEmailAddress"
          maxlength="254"
        />
      </div>
    </div>

    <!-- Test Email Modal Footer -->
    <div class="test-email-modal-footer">
      <button class="btn btn-secondary btn-large" (click)="onCloseTestEmailModal()">Cancel</button>
      <button class="btn btn-primary btn-large" (click)="onSendTestEmail()">Send</button>
    </div>
  </div>
</div>

<!-- File Upload Area Label Template (reused for logo and image upload sections) -->
<ng-template #uploadAreaLabel let-inputId="inputId" let-dimensions="dimensions">
  <label [attr.for]="inputId" class="file-upload-label">
    <div class="upload-icon">
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M17.7148 13.1152V16.4486C17.7148 16.8906 17.5392 17.3145 17.2267 17.6271C16.9141 17.9396 16.4902 18.1152 16.0482 18.1152H4.38151C3.93948 18.1152 3.51556 17.9396 3.203 17.6271C2.89044 17.3145 2.71484 16.8906 2.71484 16.4486V13.1152"
          stroke="#15172E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M14.3822 7.2819L10.2155 3.11523L6.04883 7.2819"
          stroke="#15172E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M10.2148 3.11523V13.1152"
          stroke="#15172E"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
    <span class="upload-text mobile-hide"
      >Drag & drop your files here or <strong>browse</strong> to upload</span
    >
    <span class="upload-text mobile-show">
      <span class="link">Click here</span> to upload image</span
    >
    <span class="upload-info"
      >.png, .jpg, .jpeg Max file size - 5MB, Max dimensions - {{ dimensions.width }}x{{
        dimensions.height
      }}px</span
    >
  </label>
</ng-template>
